<app-exam-header [pageTitle]="'Events'"></app-exam-header>
<!-- Hero Section -->
<section class="hero-section">
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <h1 class="hero-title">Explore the Upcoming Events</h1>
                <p class="hero-subtitle">Discover and participate in our exciting events</p>
            </div>
            <div class="col-md-4 d-none d-md-block">
                <div class="hero-cta">
                    <div class="cta-card">
                        <p class="cta-text">
                            Step into a world of <strong>transformation</strong> and limitless possibilities! 
                            <span class="cta-text-highlight">Be part of Sharani's events</span> and witness the 
                            life-changing impact for yourself. Join today to learn more!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Latest Event (Overlapping with Hero) -->
<section class="latest-event-section">
    <div class="container">
        <div class="latest-event" *ngIf="events && events.length > 0">
            <article class="pbmit-blog-style-1">
                <a [href]="'/event/' + events[0].id" class="post-item overlay-card no-hover" style="cursor: pointer;">
                    <div class="pbmit-featured-container">
                        <div class="pbmit-featured-wrapper">
                            <img [src]="siteUrl+'api/static'+events[0].image" class="img-fluid" alt="">
                            <div class="overlay-content">
                                <div class="event-meta-container">
                                    <div class="pbmit-meta-date-wrapper">					
                                        <span class="pbmit-day">{{events[0].event_date | date:'dd'}}</span>
                                        <span>{{events[0].event_date | date:'MMM'}}</span>
                                    </div>
                                    <div class="event-category">
                                        <span>{{events[0].category}}</span>
                                    </div>
                                </div>
                                <div class="title-row">
                                    <h3 class="pbmit-post-title">
                                        <a>{{events[0].name}}</a>
                                    </h3>
                                    <div class="pbmit-read-more-link">
                                        <a><span>Read More</span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </article>
        </div>
    </div>
</section>

<!-- Regular Events Grid -->
<section class="section-xxl events-grid">
    <div class="container">
        <div class="row">
            <div class="col-md-6" *ngFor="let event of events.slice(1)">
                <article class="pbmit-blog-style-1">
                    <a [href]="'/event/' + event.id" class="post-item overlay-card no-hover" style="cursor: pointer;">
                        <div class="pbmit-featured-container">
                            <div class="pbmit-featured-wrapper">
                                <img [src]="siteUrl+'api/static'+event.image" class="img-fluid" alt="">
                                <div class="overlay-content">
                                    <div class="event-meta-container">
                                        <div class="pbmit-meta-date-wrapper">					
                                            <span class="pbmit-day">{{event.event_date | date:'dd'}}</span>
                                            <span>{{event.event_date | date:'MMM'}}</span>
                                        </div>
                                        <div class="event-category">
                                            <span>{{event.category}}</span>
                                        </div>
                                    </div>
                                    <div class="title-row">
                                        <h3 class="pbmit-post-title">
                                            <a>{{event.name}}</a>
                                        </h3>
                                        <div class="pbmit-read-more-link">
                                            <a><span>Read More</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </article>
            </div>
        </div>
    </div>
</section>

<app-exam-footer></app-exam-footer>